import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingSpinnerProps {
  size?: 'sm';
  className?: string;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size, 
  className = '', 
  text = 'Loading...' 
}) => {
  return (
    <div className={`loading-spinner ${className}`}>
      <Spinner animation="border" size={size} role="status">
        <span className="visually-hidden">{text}</span>
      </Spinner>
      {text && (
        <div className="mt-2 text-muted">
          {text}
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
